import React from 'react';
import { ColumnType } from '@base/ui/components/dataTable';
import { Referal } from '@base/features/user/model/interfaces';

export const feeStatisticsCols: ColumnType<Referal>[] = [
  {
    title: 'referred_player_name',
    dataIndex: 'referedName',
    render: (statistics) => <span>{statistics.referedName}</span>,
  },
  {
    title: 'registration_date',
    dataIndex: 'registrationDate',
    render: (statistics) => <span>{statistics.registrationDate}</span>,
  },
  {
    title: 'referral_fees_in_tickets',
    dataIndex: 'feesInTickets',
    render: (statistics) => <span>{statistics.feesInTickets}</span>,
  },
];
